import { ReactElement } from "react";
import { Anchor } from "@twilio-paste/core/anchor";

const protocol = "((?:http|https|rtsp):\\/\\/)";
const domainAndSubdomains = "(?:(?:[a-zA-Z0-9][-]*)*[a-zA-Z0-9]\\.)+";
const genericTopLevelDomains =
    "aero|arpa|asia|app|" +
    "biz|buzz|" +
    "cat|com|coop|credit|" +
    "edu|" +
    "gov|" +
    "info|int|" +
    "jobs|" +
    "mil|mobi|museum|" +
    "name|net|" +
    "org|" +
    "pro|" +
    "tel|travel";
const countryTopLevelDomains =
    "a[cdefgilmnoqrstuwxz]|" +
    "b[abdefghijlmnoqrstvwyz]|" +
    "c[acdfghiklmnoruvwxyz]|" +
    "d[ejkmoz]|" +
    "e[ceghrstu]|" +
    "f[ijkmor]|" +
    "g[abdefghilmnpqrstuwy]|" +
    "h[kmnrtu]|" +
    "i[delmnoqrst]|" +
    "j[emop]|" +
    "k[eghimnprwyz]|" +
    "l[abcikrstuvy]|" +
    "m[acdefghklmnopqrstuvwxyz]|" +
    "n[acefgilopruz]|" +
    "om|" +
    "p[aefghklmnrstwy]|" +
    "qa|" +
    "r[eosuw]|" +
    "s[abcdeghijklmnorstuvxyz]|" +
    "t[cdfghjklmnoprtvwz]|" +
    "u[agkmsyz]|" +
    "v[aceginu]|" +
    "w[fs]|" +
    "y[etu]|" +
    "z[amw]";
const port = "(?:\\:\\d{1,5})?";
const path = '(?:[/?#][^\\s"]*)?';
const startOfMatchedUrl = "(?:\\b|^)";
const endOfMatchedUrl = "(?:\\b|$)";

const urlRegexString = `${startOfMatchedUrl}(?:${protocol}\\S+|(?:${protocol})?${domainAndSubdomains}(?:${genericTopLevelDomains}|${countryTopLevelDomains})${port}${path})${endOfMatchedUrl}`;
const urlRegex = new RegExp(urlRegexString, "gi");

const emailRegex =
    /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.(?:com|org|net|edu|gov|mil|info|biz|in|io|co|uk|us|ca|au|[a-z]{2})\b/i;

const combinedRegex = new RegExp(
    `${urlRegex.source}|${emailRegex.source}`,
    "gi"
);

export const parseMessageBody = (
    body: string,
    belongToCurrentUser: boolean
) => {
    const renderedResult: Array<ReactElement | string> = [];

    const lineBreakRegexp = new RegExp(/[\n\r]/);
    const lines = body.split(lineBreakRegexp);

    lines.forEach((line) => {
        let index = 0;
        let match;

        while ((match = combinedRegex.exec(line))) {
            const matchedText = match[0];

            // Add text before match
            renderedResult.push(line.substring(index, match.index));

            const isEmail = emailRegex.test(matchedText);

            if (isEmail) {
                renderedResult.push(
                    <Anchor
                        href={`mailto:${matchedText}`}
                        key={match.index}
                        variant={belongToCurrentUser ? "inverse" : "default"}
                    >
                        {matchedText}
                    </Anchor>
                );
            } else {
                // URL handling
                const hasProtocol = matchedText.match(protocol);
                const urlHref = hasProtocol
                    ? matchedText
                    : `http://${matchedText}`;

                renderedResult.push(
                    <Anchor
                        href={urlHref}
                        key={match.index}
                        variant={belongToCurrentUser ? "inverse" : "default"}
                    >
                        {matchedText}
                    </Anchor>
                );
            }

            index = match.index + matchedText.length;
        }

        // Add remaining text
        if (index < line.length) {
            renderedResult.push(line.substring(index));
        }

        renderedResult.push("\n");
    });

    renderedResult.pop();

    return renderedResult;
};